import { observable } from "mobx";
import { wordPressService } from "../../../../cdm/services/wordpress-service";
import { endpointConfig } from "../../../../config/api-config";

export class AdminJobPostingPageController {
  @observable loading = false;
  frameUrl = "";

  constructor(props) {
    this.props = props;
    this._initialize();
  }

  _initialize = () => {
    // wordPressService.setLoading(true);
    wordPressService.setWpHostname(endpointConfig.wp_hostname);
    this.frameUrl = `${window.location.protocol}//${
      endpointConfig.wp_hostname
    }/jobs/senior-caregiver/admin`;
  };
}
